import { useEffect } from "react";
import { getNotJoinedCommunitiesAction } from "../redux/actions/communityActions";
import { useDispatch, useSelector } from "react-redux";
import CommonLoading from "../components/loader/CommonLoading";
import CommunityCard from "../components/community/CommunityCard";
import ContentWithCards from "../components/shared/ContentWithCards";

const AllCommunities = () => {
  const dispatch = useDispatch();

  const notJoinedCommunities = useSelector(
    (state) => state.community?.notJoinedCommunities
  );

  useEffect(() => {
    dispatch(getNotJoinedCommunitiesAction());
  }, [dispatch]);

  if (!notJoinedCommunities) {
    return (
      <ContentWithCards>
        <div className="main-section flex items-center justify-center">
          <CommonLoading />
        </div>
      </ContentWithCards>
    );
  }

  return (
    <ContentWithCards>
      <div className="main-section bg-white border rounded-lg p-4 shadow-sm">
        <h2 className="text-lg font-semibold text-gray-700 mb-4 text-center border-b py-2 font-heading">
          All Communities
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {notJoinedCommunities?.map((community) => (
            <CommunityCard key={community._id} community={community} />
          ))}
        </div>
      </div>
    </ContentWithCards>
  );
};

export default AllCommunities;
